module.exports = __webpack_public_path__ + "static/media/icon-error.f0b133c9.svg";